module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_ES.5a1bc656.txt";